import {useMainStore} from "@/store";

const masqueradeOnly = () => {
    const store = useMainStore();

    if (store.isMasquerade) {
        return;
    }

    return {name: 'dashboard'};
};

export default masqueradeOnly;
